
import { Bgl, Bp, Insulin, Observation, Weight } from "../types/observation";
import { Patient, ReviewWrapper } from "../types/patient";
import { AFTER_MEAL, BED, BREAKFAST, DINNER, DefaultBreakfastEnd, DefaultBreakfastStart, DefaultDinnerEnd, DefaultDinnerStart, DefaultFastingEnd, DefaultFastingStart, DefaultLunchEnd, DefaultLunchStart, DefaultOvernightEnd, DefaultOvernightStart, FASTING, LUNCH, MORNING, OGTT, OVERNIGHT, WEEKDAYS } from "./const";

export const FormatDateForDisplay = (dateStr: string | undefined) => {
  if(dateStr === undefined || dateStr === null || dateStr.length === 0)
  { 
    return "";
  }
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-AU');
}

export const FormatTimeForDisplay = (timeStr: string | undefined) => 
{
  if(timeStr === undefined || timeStr === null)
    return "";
  var timePieces = timeStr.split(":");
  return timePieces[0]+":"+timePieces[1];
}

export const FormatBglInfoDisplay = (patient: Patient) =>
{
  const NA = "N/A";

  var ogttValues;
  if(patient.ogttFasting == null || patient.ogttFasting.length === 0 || 
    patient.ogttOneHour == null || patient.ogttOneHour.length === 0 || 
    patient.ogttTwoHour == null || patient.ogttTwoHour.length === 0)
    ogttValues = NA;
  else
    ogttValues = patient.ogttFasting + "/" + patient.ogttOneHour + "/" + patient.ogttTwoHour;

  var fastingValues;
  if(patient.fastingUpper == null || patient.fastingUpper.length === 0 || 
    patient.fastingLower == null || patient.fastingLower.length === 0)
    fastingValues = NA;
  else
    fastingValues = patient.fastingUpper + "/" + patient.fastingLower;

  var afterMealValues;
  if(patient.amUpper == null || patient.amUpper.length === 0 || 
    patient.amLower == null || patient.amLower.length === 0)
    afterMealValues = NA;
  else
    afterMealValues = patient.amUpper + "/" + patient.amLower;

  return OGTT + ": " +  ogttValues + " | " + FASTING + ": " +  fastingValues + " | " + AFTER_MEAL + ": " + afterMealValues;
}

export const SetTimeslotForElement = (element: Bgl | Bp | Insulin, patient: Patient) => 
{
  var rtStr = element.recordedTime.split(":");
  var recordedDate = new Date(element.recordedDate);
  recordedDate.setHours(+rtStr[0]);
  recordedDate.setMinutes(+rtStr[1]);
  recordedDate.setSeconds(+rtStr[2]);
  element.weekDay = recordedDate.getDay();

  // if(element.type === "bgl")
  // {
  //     console.log("recordedDate " + element.recordedDate + " js date " + recordedDate);
  // }
  
  var value = "";
  if('reading' in element) // bgl
  {
    var float = parseFloat(element.reading);
    var whole = Math.floor(float);
    var decimal = (float - whole).toFixed(2);
    var x = Number(decimal.charAt(3))
    var y = Number(decimal.charAt(2))
    if(x > 5)
    {
      y++;
    }
    whole = whole + y/10;
    value = whole.toString();
    element.reading = value;
  }
  if('dose' in element) // insulin
    value = element.dose;
  if('heartRate' in element) // bp
    value = element.systolic + "/" + element.diastolic;

  if('context' in element)
  {
    if(element.context == null || element.context === undefined || element.context === "0")
    {
      if (MatchTimeslot(recordedDate, patient.breakfastStart, patient.breakfastEnd)) 
      {
        element.postBreakfast = value;
      } 
      else if (MatchTimeslot(recordedDate, patient.lunchStart, patient.lunchEnd)) 
      {
        element.postLunch = value;
      } 
      else if (MatchTimeslot(recordedDate, patient.dinnerStart,patient.dinnerEnd)) 
      {
        element.postDinner = value;
      }
      else if (MatchTimeslot(recordedDate, patient.overnightStart,patient.overnightEnd)) 
      {
        element.overnight = value;
      }
      else if (MatchTimeslot(recordedDate, patient.fastingStart, patient.fastingEnd)) 
      {
        element.fasting = value;
      }
    }
    else
    {
      if(element.context.includes(MORNING) || element.context.includes(FASTING))
        element.fasting = value;
      else if(element.context.includes(BREAKFAST))
        element.postBreakfast = value;
      else if(element.context.includes(LUNCH))
        element.postLunch = value; 
      else if(element.context.includes(DINNER))
        element.postDinner = value; 
      else if(element.context.includes(BED))
        element.beforeBed = value;
      else if(element.context.includes(OVERNIGHT))
        element.overnight = value;
      else {
        // We don't have a match for the context, guess the context based on timing
        if (MatchTimeslot(recordedDate, patient.breakfastStart, patient.breakfastEnd)) 
        {
          //console.log("context guessing beakfast");
          element.postBreakfast = value;
        } 
        else if (MatchTimeslot(recordedDate, patient.lunchStart, patient.lunchEnd)) 
        {
          console.log("context guessing lunch");
          element.postLunch = value;
        } 
        else if (MatchTimeslot(recordedDate, patient.dinnerStart,patient.dinnerEnd)) 
        {
          //console.log("context guessing dinner");
          element.postDinner = value;
        } 
        else if (MatchTimeslot(recordedDate, patient.overnightStart,patient.overnightEnd)) 
        {
          //console.log("context guessing overnight");
          element.overnight = value;
        } 
        else if (MatchTimeslot(recordedDate, patient.fastingStart, patient.fastingEnd)) 
        {
          //console.log("context guessing fasting");
          element.fasting = value;
        }
        else {
          console.log("context guessing could not guess");
        }
      }
    }
  }
};

export const MatchTimeslot = (recordedDate: Date, start:string, end: string) =>
{
  var startBits = start.split(":");
  var startDate = new Date();
  startDate.setHours(+startBits[0]);
  startDate.setMinutes(+startBits[1]);
  startDate.setSeconds(0);

  var endBits = end.split(":");
  var endDate = new Date();
  endDate.setHours(+endBits[0]);
  endDate.setMinutes(+endBits[1]);
  endDate.setSeconds(0);

  //console.log("recordedDate hours " + recordedDate.getHours() + " startHours " + startDate.getHours() + " endHours " + endDate.getHours());

  var matched = false;
  if(recordedDate.getHours() >= startDate.getHours() && recordedDate.getHours() <= endDate.getHours())
  {
    //console.log("recordedDate minutes " + recordedDate.getMinutes() + " startHours " + startDate.getMinutes() + " endHours " + endDate.getMinutes());

    if(recordedDate.getMinutes() >= startDate.getMinutes() && recordedDate.getMinutes() <= endDate.getMinutes())
    {
      matched = true;
    }
  }
  return matched;
}

export const Initialise = (patient:Patient) =>
{
  if(patient.fastingStart == null)
    patient.fastingStart = DefaultFastingStart;
  if(patient.fastingEnd == null)
    patient.fastingEnd = DefaultFastingEnd;
  if(patient.breakfastStart == null)
    patient.breakfastStart = DefaultBreakfastStart;
  if(patient.breakfastEnd == null)
    patient.breakfastEnd = DefaultBreakfastEnd;
  if(patient.lunchStart == null)
    patient.lunchStart = DefaultLunchStart;
  if(patient.lunchEnd == null)
    patient.lunchEnd = DefaultLunchEnd;
  if(patient.dinnerStart == null)
    patient.dinnerStart = DefaultDinnerStart;
  if(patient.dinnerEnd == null)
    patient.dinnerEnd = DefaultDinnerEnd;
  if(patient.overnightStart == null)
    patient.overnightStart = DefaultOvernightStart;
  if(patient.overnightEnd == null)
    patient.overnightEnd = DefaultOvernightEnd;
}

export const ProcessObservations = (observations: Observation[]): Map<string, Array<Observation>> => {

  let observationMap = new Map<string, Array<Observation>>();

  observations.forEach(function (value: object) {
    type ObjectKey = keyof typeof value;
    const type = "type" as ObjectKey;
    const key = value[type];

    var observation = undefined;
    if (key === "bgl") observation = value as Bgl;

    if (key === "bp") observation = value as Bp;

    if (key === "insulin") observation = value as Insulin;

    if (key === "weight") observation = value as Weight;

    if (observation !== undefined) {
      if (observationMap.has(key)) {
        observationMap.get(key)?.push(observation);
      } else {
        var arr = Array<Observation>();
        arr.push(observation);
        observationMap.set(key, arr);
      }
      //if(key === "bgl") console.log(JSON.stringify(observation));
    }
    // else
    // {
    //   console.log("observation undefined");
    // }
  });

  return observationMap;
}

export const ProcessReviewData = (reviewData: ReviewWrapper, patient:Patient) => {
  patient.reviews = reviewData.reviews;
  patient.observations = ProcessObservations(reviewData.observations);
  patient.medicationRegimeGroups = reviewData.regimeGroups;
};

export const GetGraphLabels = () => {
  var today = new Date();
  var day = today.getDay() + 1; // day as weekday number
  var graphLabels: Array<string> = new Array<string>();
  WEEKDAYS.map(() => {
    day = day - 1;
    if (day < 0) {
      day = 7 + day;
    }
    return graphLabels.push(WEEKDAYS[day]);
  });
  return graphLabels.reverse();
}

export const GetTimeInterval = (endTime:String, startTime:String)=>{
  var end = endTime.split(":")
  var start = startTime.split(":")

  if(end[0] < start[0]){
    if(start[1]!== "00" && end[1]==="00"){
      return 24 - Number(start[0]) + Number(end[0])-1
    }
    else if((start[1]=== "00" && end[1]!=="00")){
      return 24 - Number(start[0]) + Number(end[0])+1
    }
    else{
      return 24 - Number(start[0]) + Number(end[0])
    }
  }
  else{
    if(start[1]!== "00" && end[1]==="00"){
      return Number(end[0])-Number(start[0])-1
    }
    else if((start[1]=== "00" && end[1]!=="00")){
      return Number(end[0])-Number(start[0])+1
    }
    else{
      return Number(end[0])-Number(start[0])
    }
  }
}

export const GetCurrentDate = () => {
  var today = new Date().toLocaleDateString("en-AU", {timeZone: "Australia/Melbourne"}).replace(/\//g, "-") 
  var todaySliced = today.slice(0,10)
  return todaySliced.split("-").reverse().join("-");
}

export const Get28DaysDates = (periodEnding:Date) => {
  const dayOfMonth = periodEnding.getDate();
  const dates = [];
  for(let i = 0; i < 27; i ++){
    const date = new Date();
    date.setDate(dayOfMonth - i);
    dates.push(date.toLocaleDateString().slice(0, 5));
  }
  return dates;
}

export const GetCurrentTime = () => {
  const now = new Date();
  const padZero = (num: number) => (num < 10 ? `0${num}` : num);
  const hours = padZero(now.getHours());
  const minutes = padZero(now.getMinutes());
  const seconds = padZero(now.getSeconds());
  return `${hours}:${minutes}:${seconds}`;
};

export const GetHourList = (patient: Patient) => {
  var overnightStart = patient.overnightStart;
  var overnightHour = overnightStart.split(":")[0];
  var overnightMinute = overnightStart.split(":")[1];

  let startWith: number = Number(overnightHour);
  let out = [];
  if (overnightMinute !== "00") {
    startWith = Number(overnightHour) + 1;
  }

  if (startWith === 24) {
    for (let i = 0; i < 24; i++) {
      out.push(i);
    }
  } else {
    for (let j = startWith; j < 24; j++) {
      out.push(j);
    }
    for (let k = 0; k < startWith; k++) {
      out.push(k);
    }
  }
  return out;
};